import AuditRepository from "@/repositories/audit/AuditRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'audit',
    namespaced: true,
    state: {
        ...makeState(),
        allByModelId: null
    },
    getters: {
        ...makeGetters(),

        isLoadingCurrent(state) {
            return state.isLoadingCurrent
        },
        allByModelId(state) {
            return state.allByModelId
        }
    },
    mutations: {
        ...makeMutations(),
        setAllByModelId(state, string) {
            state.allByModelId = string
        }
    },
    actions: {
        async listAll({commit, state}, params) {
            commit('setLoading', true)
            await AuditRepository.listAll({...params, ...state.pagination})
                .then(response => {
                    commit('setPagination', {
                        page: response.data.data.current_page,
                        per_page: response.data.data.per_page,
                        total: response.data.data.total
                    })
                    commit('setAll', response.data.data.data)
                }).catch(console.error)
            commit('setLoading', false)
        },        
        async listAllByModelId({commit, state}, modelId) {
            commit('setLoading', true)
            await AuditRepository.listAllByModelId(modelId, {...state.pagination})
                .then(response => {
                    commit('setPagination', {
                        page: response.data.data.current_page,
                        per_page: response.data.data.per_page,
                        total: response.data.data.total
                    })
                    commit('setAllByModelId', response.data.data.data)
                }).catch(console.error)
            commit('setLoading', false)
        }
    }
}
